<template>
	<el-card v-loading="loading" shadow="hover">
		<div class="row row-cols-auto justify-content-between g-1">
			<el-space spacer=":" :size="4">
				<span>Persentase Kelangkapan Detail Siswa</span>
				<transition name="slide-up" mode="out-in">
					<div :key="progresData.progres_detail_siswa" :class="progresData.progres_detail_siswa_class">{{ progresData.progres_detail_siswa }}%</div>
				</transition>
			</el-space>
			<div class="col-auto ms-auto" v-if="isPengelola || isWaliKelas || isSiswa">
				<transition name="fade" mode="out-in">
					<el-button
						:key="edit"
						:type="edit ? 'info' : 'primary'"
						:icon="edit ? 'Close' : 'Edit'"
						size="small"
						:disabled="progresData.kunci_data === 1 && !isPengelola"
						plain
						round
						@click="edit = !edit">
						<el-tooltip content="Akses edit data terkunci" :offset="24" v-if="progresData.kunci_data === 1 && !isPengelola">Edit</el-tooltip>
						<span v-else>
							{{ edit ? "Batal Edit" : "Edit" }}
						</span>
					</el-button>
				</transition>
			</div>
		</div>
		<hr />
		<transition name="fade" mode="out-in">
			<template v-if="edit">
				<el-form
					:model="form"
					:rules="rules"
					@submit.prevent="updateData"
					ref="formDetailSiswa"
					label-width="auto"
					label-position="top"
					require-asterisk-position="right"
					:disabled="loadingForm"
					:scroll-to-error="loadingForm"
					inline-message>
					<el-row :gutter="12">
						<el-divider content-position="left">Identitas Dasar</el-divider>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item prop="nisn">
								<template #label>
									NISN
									<el-tooltip content="Cek NISN">
										<el-link type="primary" :underline="false" href="https://nisn.data.kemdikbud.go.id/index.php/Cindex/formcaribynama" target="_blank">
											<el-icon>
												<i class="bi bi-box-arrow-in-up-right"></i>
											</el-icon>
										</el-link>
									</el-tooltip>
								</template>
								<el-input v-model="form.nisn" :placeholder="detailSiswa.nisn || 'Nomor Induk Siswa Nasional'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="NIK" prop="nik">
								<el-input v-model="form.nik" :placeholder="detailSiswa.nik || 'Nomor Induk Kependudukan'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="No. KK" prop="no_kk">
								<el-input v-model="form.no_kk" :placeholder="detailSiswa.no_kk || 'Nomor Kartu Keluarga'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="No. Reg. Akta Lahir" prop="no_reg_akta_lahir">
								<el-input v-model="form.no_reg_akta_lahir" :placeholder="detailSiswa.no_reg_akta_lahir || 'Nomor Registrasi Akta Kelahiran'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Tempat Lahir" prop="tempat_lahir">
								<el-select
									v-model="form.tempat_lahir"
									filterable
									popper-class="tempat-lahir-dropdown"
									:placeholder="detailSiswa.nama_tempat_lahir || 'Pilih tempat kelahiran'"
									clearable
									fit-input-width
									@visible-change="onVisibleChangeTempatLahir"
									@popup-scroll="handleScrollTempatLahir"
									@keyup="onKeyupTempatLahir">
									<el-option v-for="tl in listTempatLahir" :key="tl.wilayah_id" :label="tl.nama" :value="tl.wilayah_id" />
									<template #empty>
										<div v-if="isFetchingTempatLahir || loadingTempatLahir" class="fst-italic">Memuat data...</div>
										<div v-else>Tidak ada data ditemukan</div>
									</template>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="4">
							<el-form-item label="Tanggal Lahir" prop="tanggal_lahir">
								<el-date-picker
									v-model="form.tanggal_lahir"
									type="date"
									format="DD MMMM YYYY"
									value-format="YYYY-MM-DD"
									:placeholder="detailSiswa.tanggal_lahir_styled || 'Pilih tanggal lahir'"
									class="w-100"
									clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="10" :xl="8">
							<el-form-item label="Penulisan TTL" prop="penulisan_ttl">
								<el-input v-model="form.penulisan_ttl" :placeholder="detailSiswa.penulisan_ttl || 'Penulisan Tempat dan Tanggal Lahir'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="6" :md="5" :xl="3">
							<el-form-item label="Anak ke" prop="anak_ke">
								<el-input v-model="form.anak_ke" type="number" :placeholder="detailSiswa.anak_ke?.toString() || 'Anak ke-'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="6" :md="5" :xl="3">
							<el-form-item label="dari" prop="jumlah_saudara">
								<el-input v-model="form.jumlah_saudara" type="number" :placeholder="detailSiswa.jumlah_saudara?.toString() || '-'" clearable>
									<template #suffix>bersaudara</template>
								</el-input>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Data Fisik</el-divider>
						<el-col :xs="12" :sm="8" :md="5" :xl="3">
							<el-form-item label="Tinggi Badan" prop="tinggi_badan">
								<el-input v-model="form.tinggi_badan" type="number" :placeholder="detailSiswa.tinggi_badan?.toString() || '-'" clearable>
									<template #suffix>cm</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="12" :sm="8" :md="5" :xl="3">
							<el-form-item label="Berat Badan" prop="berat_badan">
								<el-input v-model="form.berat_badan" type="number" :placeholder="detailSiswa.berat_badan?.toString() || '-'" clearable>
									<template #suffix>kg</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="12" :sm="8" :md="5" :xl="3">
							<el-form-item label="Lingkar Kepala" prop="lingkar_kepala">
								<el-input v-model="form.lingkar_kepala" type="number" :placeholder="detailSiswa.lingkar_kepala?.toString() || '-'" clearable>
									<template #suffix>cm</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="9" :xl="6">
							<el-form-item label="Berkebutuhan Khusus" prop="berkebutuhan_khusus_id">
								<el-select v-model="form.berkebutuhan_khusus_id" filterable :placeholder="detailSiswa.jenis_kebutuhan_khusus || 'Pilih jika ada'" clearable>
									<el-option v-for="bk in listKebutuhanKhusus" :key="bk.berkebutuhan_khusus_id" :label="bk.jenis" :value="bk.berkebutuhan_khusus_id" />
								</el-select>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Alamat & Transportasi</el-divider>
						<el-col :xs="24" :sm="14" :md="12" :xl="8">
							<el-form-item label="Alamat" prop="alamat">
								<el-input v-model="form.alamat" type="textarea" :rows="2" :placeholder="detailSiswa.alamat || 'Alamat pelengkap: nama jalan, dusun, dsb.'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="12" :sm="5" :md="4" :xl="2">
							<el-form-item label="RT" prop="rt">
								<el-input v-model="form.rt" type="number" :placeholder="detailSiswa.rt?.toString() || '-'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="12" :sm="5" :md="4" :xl="2">
							<el-form-item label="RW" prop="rw">
								<el-input v-model="form.rw" type="number" :placeholder="detailSiswa.rw?.toString() || '-'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Provinsi" prop="provinsi">
								<el-select v-model="form.provinsi" filterable :placeholder="alamatAwal.nama_prov || 'Pilih provinsi'" clearable>
									<el-option v-for="prov in listProvinsi" :key="prov.wilayah_id" :label="prov.nama" :value="prov.wilayah_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Kabupaten/Kota" prop="kabupaten_kota">
								<el-select v-model="form.kabupaten_kota" filterable :placeholder="alamatAwal.nama_kab_kota || 'Pilih kabupaten/kota'" clearable>
									<el-option v-for="kk in listKabKota" :key="kk.wilayah_id" :label="kk.nama" :value="kk.wilayah_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Kecamatan" prop="kecamatan">
								<el-select v-model="form.kecamatan" filterable :placeholder="alamatAwal.nama_kec || 'Pilih kecamatan'" clearable>
									<el-option v-for="kec in listKecamatan" :key="kec.wilayah_id" :label="kec.nama" :value="kec.wilayah_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Desa" prop="desa">
								<el-select v-model="form.desa" filterable :placeholder="alamatAwal.nama_desa || 'Pilih desa'" clearable>
									<el-option v-for="ds in listDesa" :key="ds.wilayah_id" :label="ds.nama" :value="ds.wilayah_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :md="16" :xl="12">
							<el-form-item label="Tautan Google Maps" prop="google_maps">
								<el-input v-model="form.google_maps" :placeholder="detailSiswa.google_maps || 'https://maps.google.com/...'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="7" :xl="6">
							<el-form-item label="Tempat Tinggal" prop="tempat_tinggal_id">
								<el-select v-model="form.tempat_tinggal_id" filterable :placeholder="detailSiswa.jenis_tempat_tinggal || 'Pilih jenis tempat tinggal'" clearable>
									<el-option v-for="tt in listTempatTinggal" :key="tt.tempat_tinggal_id" :label="tt.jenis" :value="tt.tempat_tinggal_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="7" :xl="6">
							<el-form-item label="Moda Transportasi" prop="moda_transportasi_id">
								<el-select v-model="form.moda_transportasi_id" filterable :placeholder="detailSiswa.jenis_transportasi || 'Pilih jenis moda transportasi'" clearable>
									<el-option v-for="mt in listModaTransportasi" :key="mt.moda_transportasi_id" :label="mt.jenis" :value="mt.moda_transportasi_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="6" :md="5" :xl="3">
							<el-form-item label="Jarak ke Sekolah" prop="jarak_tempat_tinggal">
								<el-input v-model="form.jarak_tempat_tinggal" type="number" :placeholder="detailSiswa.jarak_tempat_tinggal?.toString() || '-'" clearable>
									<template #suffix>km</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="6" :md="5" :xl="3">
							<el-form-item label="Waktu Tempuh" prop="waktu_tempuh">
								<el-input v-model="form.waktu_tempuh" type="number" :placeholder="detailSiswa.waktu_tempuh?.toString() || '-'" clearable>
									<template #suffix>menit</template>
								</el-input>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Data Pendidikan</el-divider>
						<el-col :xs="24" :md="16" :xl="10">
							<el-form-item label="Asal Sekolah" prop="npsn_asal_smp">
								<el-select
									popper-class="asal-smp-dropdown"
									:placeholder="detailSiswa.nama_asal_sekolah ? `${detailSiswa.nama_asal_sekolah} (${detailSiswa.npsn_asal_smp})` : 'Pilih Asal Sekolah (SMP/MTs)'"
									v-model="form.npsn_asal_smp"
									filterable
									clearable
									fit-input-width
									@visible-change="onVisibleChangeAsalSMP"
									@popup-scroll="handleScrollAsalSMP"
									@keyup="onKeyupAsalSMP">
									<el-option v-for="smp in listAsalSMP" :key="smp.npsn" :label="`${smp.nama} (${smp.npsn})`" :value="smp.npsn">
										<el-text truncated>
											<span>{{ smp.nama }}</span>
											(<strong>{{ smp.npsn }}</strong
											>)
											<small class="fst-italic">~ {{ smp.alamat }}</small>
										</el-text>
									</el-option>
									<template #empty>
										<div v-if="isFetchingAsalSMP || loadingAsalSMP" class="fst-italic">Memuat data...</div>
										<div v-else>Tidak ada data ditemukan</div>
									</template>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="8">
							<el-form-item label="No. Seri Ijazah" prop="no_seri_ijazah_smp">
								<el-input v-model="form.no_seri_ijazah_smp" :placeholder="detailSiswa.no_seri_ijazah_smp || 'Seri Ijazah SMP/MTs'" clearable />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Pendidikan Dasar" prop="pendidikan_dasar_id">
								<el-select v-model="form.pendidikan_dasar_id" filterable :placeholder="detailSiswa.deskripsi_pd || 'Pilih jenis'" clearable>
									<el-option v-for="pd in listPendidikanDasar" :key="pd.pendidikan_dasar_id" :label="pd.deskripsi" :value="pd.pendidikan_dasar_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="4">
							<el-form-item label="Pernah PAUD Formal" prop="pernah_paud_formal">
								<el-radio-group v-model="form.pernah_paud_formal">
									<el-radio :value="1">
										Ya
										<em class="text-body-tertiary" v-if="detailSiswa.pernah_paud_formal === 1">(data awal)</em>
									</el-radio>
									<el-radio :value="0">
										Tidak
										<em class="text-body-tertiary" v-if="detailSiswa.pernah_paud_formal === 0">(data awal)</em>
									</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="4">
							<el-form-item label="Pernah PAUD Nonformal" prop="pernah_paud_nonformal">
								<el-radio-group v-model="form.pernah_paud_nonformal">
									<el-radio :value="1">
										Ya
										<em class="text-body-tertiary" v-if="detailSiswa.pernah_paud_nonformal === 1">(data awal)</em>
									</el-radio>
									<el-radio :value="0">
										Tidak
										<em class="text-body-tertiary" v-if="detailSiswa.pernah_paud_nonformal === 0">(data awal)</em>
									</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Minat</el-divider>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Hobi" prop="hobi_id">
								<el-select v-model="form.hobi_id" filterable :placeholder="detailSiswa.nama_hobi || 'Pilih hobi'" clearable>
									<el-option v-for="h in listHobi" :key="h.hobi_id" :label="h.nama" :value="h.hobi_id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-form-item label="Cita-cita" prop="cita_cita_id">
								<el-select v-model="form.cita_cita_id" filterable :placeholder="detailSiswa.nama_cita_cita || 'Pilih cita-cita'" clearable>
									<el-option v-for="cc in listCitaCita" :key="cc.cita_cita_id" :label="cc.nama" :value="cc.cita_cita_id" />
								</el-select>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Berkas Pendukung</el-divider>
						<el-col :xs="24" :md="12">
							<el-form-item label="Foto Siswa" prop="foto_diri">
								<el-space alignment="start" direction="vertical">
									<el-space wrap>
										<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleFotoDiriChange" accept="image/*">
											<template #trigger>
												<transition name="fade" mode="out-in">
													<el-button v-if="detailSiswa.foto_diri || form.foto_diri" icon="Refresh" type="primary" plain>Ubah gambar</el-button>
													<el-button v-else icon="Camera" type="info">Pilih gambar</el-button>
												</transition>
											</template>
										</el-upload>
										<transition name="fade" mode="out-in">
											<el-button v-if="form.foto_diri" icon="Delete" type="danger" plain @click="handleFotoDiriChange(null)"> Hapus </el-button>
										</transition>
									</el-space>
									<el-space wrap :spacer="form.foto_diri ? switchSpacer : ''">
										<el-image
											v-if="detailSiswa.foto_diri"
											style="width: 150px; height: auto"
											:src="detailSiswa.previewFotoDiri"
											:preview-src-list="[detailSiswa.previewFotoDiri]"
											show-progress
											fit="cover"
											lazy
											class="shadow bg-white border">
											<template #error>
												<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
													<el-icon class="fs-2"><Picture /></el-icon>
													<em class="small">Gagal dimuat</em>
												</el-space>
											</template>
										</el-image>
										<transition name="slide-up" mode="out-in">
											<el-image
												v-if="form.foto_diri"
												:key="form.foto_diri"
												style="width: 150px; height: auto"
												:src="form.previewFotoDiri"
												:preview-src-list="[form.previewFotoDiri]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
										</transition>
									</el-space>
								</el-space>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :md="12">
							<el-form-item label="Foto Ijazah SMP/MTs" prop="foto_ijazah_smp">
								<el-space alignment="start" direction="vertical">
									<el-space wrap>
										<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleIjazahChange" accept="image/*">
											<template #trigger>
												<transition name="fade" mode="out-in">
													<el-button v-if="detailSiswa.foto_ijazah_smp || form.foto_ijazah_smp" icon="Refresh" type="primary" plain>Ubah gambar</el-button>
													<el-button v-else icon="Camera" type="info">Pilih gambar</el-button>
												</transition>
											</template>
										</el-upload>
										<transition name="fade" mode="out-in">
											<el-button v-if="form.foto_ijazah_smp" icon="Delete" type="danger" plain @click="handleIjazahChange(null)"> Hapus </el-button>
										</transition>
									</el-space>
									<el-space wrap :spacer="form.foto_ijazah_smp ? switchSpacer : ''">
										<el-image
											v-if="detailSiswa.foto_ijazah_smp"
											style="width: 150px; height: auto"
											:src="detailSiswa.previewFotoIjazahSMP"
											:preview-src-list="[detailSiswa.previewFotoIjazahSMP]"
											show-progress
											fit="cover"
											lazy
											class="shadow bg-white border">
											<template #error>
												<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
													<el-icon class="fs-2"><Picture /></el-icon>
													<em class="small">Gagal dimuat</em>
												</el-space>
											</template>
										</el-image>
										<transition name="slide-up" mode="out-in">
											<el-image
												v-if="form.foto_ijazah_smp"
												:key="form.foto_ijazah_smp"
												style="width: 150px; height: auto"
												:src="form.previewFotoIjazahSMP"
												:preview-src-list="[form.previewFotoIjazahSMP]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
										</transition>
									</el-space>
								</el-space>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :md="12">
							<el-form-item label="Foto Kartu Keluarga" prop="foto_kk">
								<el-space alignment="start" direction="vertical">
									<el-space wrap>
										<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleKKChange" accept="image/*">
											<template #trigger>
												<transition name="fade" mode="out-in">
													<el-button v-if="detailSiswa.foto_kk || form.foto_kk" icon="Refresh" type="primary" plain>Ubah gambar</el-button>
													<el-button v-else icon="Camera" type="info">Pilih gambar</el-button>
												</transition>
											</template>
										</el-upload>
										<transition name="fade" mode="out-in">
											<el-button v-if="form.foto_kk" icon="Delete" type="danger" plain @click="handleKKChange(null)"> Hapus </el-button>
										</transition>
									</el-space>
									<el-space wrap :spacer="form.foto_kk ? switchSpacer : ''">
										<el-image
											v-if="detailSiswa.foto_kk"
											style="width: 150px; height: auto"
											:src="detailSiswa.previewFotoKK"
											:preview-src-list="[detailSiswa.previewFotoKK]"
											show-progress
											fit="cover"
											lazy
											class="shadow bg-white border">
											<template #error>
												<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
													<el-icon class="fs-2"><Picture /></el-icon>
													<em class="small">Gagal dimuat</em>
												</el-space>
											</template>
										</el-image>
										<transition name="slide-up" mode="out-in">
											<el-image
												v-if="form.foto_kk"
												:key="form.foto_kk"
												style="width: 150px; height: auto"
												:src="form.previewFotoKK"
												:preview-src-list="[form.previewFotoKK]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
										</transition>
									</el-space>
								</el-space>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :md="12">
							<el-form-item label="Foto Akta Kelahiran" prop="foto_akta">
								<el-space alignment="start" direction="vertical">
									<el-space wrap>
										<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleAktaChange" accept="image/*">
											<template #trigger>
												<transition name="fade" mode="out-in">
													<el-button v-if="detailSiswa.foto_akta || form.foto_akta" icon="Refresh" type="primary" plain>Ubah gambar</el-button>
													<el-button v-else icon="Camera" type="info">Pilih gambar</el-button>
												</transition>
											</template>
										</el-upload>
										<transition name="fade" mode="out-in">
											<el-button v-if="form.foto_akta" icon="Delete" type="danger" plain @click="handleAktaChange(null)"> Hapus </el-button>
										</transition>
									</el-space>
									<el-space wrap :spacer="form.foto_akta ? switchSpacer : ''">
										<el-image
											v-if="detailSiswa.foto_akta"
											style="width: 150px; height: auto"
											:src="detailSiswa.previewFotoAkta"
											:preview-src-list="[detailSiswa.previewFotoAkta]"
											show-progress
											fit="cover"
											lazy
											class="shadow bg-white border">
											<template #error>
												<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
													<el-icon class="fs-2"><Picture /></el-icon>
													<em class="small">Gagal dimuat</em>
												</el-space>
											</template>
										</el-image>
										<transition name="slide-up" mode="out-in">
											<el-image
												v-if="form.foto_akta"
												:key="form.foto_akta"
												style="width: 150px; height: auto"
												:src="form.previewFotoAkta"
												:preview-src-list="[form.previewFotoAkta]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
										</transition>
									</el-space>
								</el-space>
							</el-form-item>
						</el-col>

						<el-divider content-position="left">Catatan</el-divider>
						<el-col :xs="24" :lg="16" :xl="12">
							<el-form-item label="" prop="catatan">
								<el-input v-model="form.catatan" type="textarea" :rows="2" :placeholder="detailSiswa.catatan || 'Catatan (opsional)'" clearable />
							</el-form-item>
						</el-col>

						<el-divider />
						<el-form-item class="ms-auto">
							<el-button type="info" plain @click="edit = false">Batal</el-button>
							<el-button type="success" native-type="submit" :loading="loadingForm">Simpan</el-button>
						</el-form-item>
					</el-row>
				</el-form>
			</template>

			<div v-else>
				<el-descriptions direction="vertical" border :column="24" size="small">
					<el-descriptions-item v-for="d in descriptions" :key="d" :label="d.label" :span="d.colspan[breakpoint]" :rowspan="d.rowspan[breakpoint]">
						<template v-if="d.key_check">
							<transition name="slide-up" mode="out-in">
								<div v-if="detailSiswa[d.key_check] || typeof detailSiswa[d.key_check] === 'number'" :key="detailSiswa[d.key_val]">
									<a v-if="d.type === 'link'" :href="detailSiswa[d.key_val]" target="_blank" rel="noopener noreferrer">{{ detailSiswa[d.key_val] }}</a>
									<el-image
										v-else-if="d.type === 'image'"
										style="width: 150px; height: auto"
										:src="detailSiswa[d.key_val]"
										:preview-src-list="[detailSiswa[d.key_val]]"
										show-progress
										fit="cover"
										lazy
										class="shadow bg-white border">
										<template #error>
											<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
												<el-icon class="fs-2"><Picture /></el-icon>
												<em class="small">Gagal dimuat</em>
											</el-space>
										</template>
									</el-image>
									<span v-else>{{ d.prefix }}{{ detailSiswa[d.key_val] }}{{ d.suffix }}</span>
								</div>
								<div v-else :class="d.fallbackClass || 'text-secondary fst-italic'">{{ d.fallback }}</div>
							</transition>
						</template>
						<template v-else>
							<span v-for="c in d.custom" :key="c">
								<transition name="slide-up" mode="out-in">
									<span v-if="detailSiswa[c.key_check]" :key="detailSiswa[c.key_val]">{{ c.prefix }}{{ detailSiswa[c.key_val] }}{{ c.suffix }}</span>
									<span v-else :class="c.fallbackClass || 'text-secondary fst-italic'">{{ c.fallback }}</span>
								</transition>
							</span>
						</template>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</transition>
	</el-card>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "DetailSiswa",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			switchSpacer: h("i", { class: "bi bi-arrow-left-right" }),
			edit: false,
			loadingForm: false,
			originalForm: null,
			alamatAwal: {
				nama_desa: null,
				nama_kec: null,
				nama_kab_kota: null,
				nama_prov: null,
			},
			form: {
				nisn: null,
				nik: null,
				no_kk: null,
				no_reg_akta_lahir: null,
				tempat_lahir: null,
				tanggal_lahir: null,
				penulisan_ttl: null,
				berkebutuhan_khusus_id: null,
				anak_ke: null,
				jumlah_saudara: null,
				tinggi_badan: null,
				berat_badan: null,
				lingkar_kepala: null,
				alamat: null,
				rt: null,
				rw: null,
				desa: null,
				kecamatan: null,
				kabupaten_kota: null,
				provinsi: null,
				google_maps: null,
				tempat_tinggal_id: null,
				moda_transportasi_id: null,
				jarak_tempat_tinggal: null,
				waktu_tempuh: null,
				npsn_asal_smp: null,
				no_seri_ijazah_smp: null,
				pendidikan_dasar_id: null,
				pernah_paud_formal: null,
				pernah_paud_nonformal: null,
				hobi_id: null,
				cita_cita_id: null,
				catatan: null,
				foto_diri: null,
				previewFotoDiri: "",
				foto_ijazah_smp: null,
				previewFotoIjazahSMP: "",
				foto_kk: null,
				previewFotoKK: "",
				foto_akta: null,
				previewFotoAkta: "",
			},
			rules: {
				nisn: [
					{ required: false, message: "", trigger: "change" },
					{ pattern: /^[0-9]{10}$/, message: "Nomor Induk Siswa Nasional terdiri dari 10 digit angka", trigger: "blur" },
				],
				nik: [
					{ required: false, message: "", trigger: "change" },
					{ pattern: /^[0-9]{16}$/, message: "Nomor Induk Kependudukan terdiri dari 16 digit angka", trigger: "blur" },
				],
				no_kk: [
					{ required: false, message: "", trigger: "change" },
					{ pattern: /^[0-9]{16}$/, message: "Nomor Kartu Keluarga terdiri dari 16 digit angka", trigger: "blur" },
				],
				anak_ke: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				jumlah_saudara: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				tinggi_badan: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				berat_badan: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				lingkar_kepala: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				rt: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				rw: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				kabupaten_kota: [],
				kecamatan: [],
				desa: [],
				jarak_tempat_tinggal: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				waktu_tempuh: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
			},
			limitSearch: 50,
			listTempatLahir: [],
			keywordTempatLahir: "",
			pageSearchTempatLahir: 1,
			searchLogTempatLahir: new Map(),
			isFetchingTempatLahir: false,
			debounceTempatLahir: null,
			loadingTempatLahir: false,
			listDesaAwal: [],
			listDesa: [],
			listKecamatanAwal: [],
			listKecamatan: [],
			listKabKotaAwal: [],
			listKabKota: [],
			listAsalSMP: [],
			optionAsalSMP: [],
			keywordAsalSMP: "",
			pageSearchAsalSMP: 1,
			searchLogAsalSMP: new Map(),
			isFetchingAsalSMP: false,
			debounceAsalSMP: null,
			loadingAsalSMP: false,
			descriptions: [
				{
					label: "Nomor Induk Siswa Nasional",
					type: "text",
					key_check: "nisn",
					key_val: "nisn",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nomor Induk Kependudukan",
					type: "text",
					key_check: "nik",
					key_val: "nik",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nomor Kartu Keluarga",
					type: "text",
					key_check: "no_kk",
					key_val: "no_kk",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nomor Registrasi Akta Kelahiran",
					type: "text",
					key_check: "no_reg_akta_lahir",
					key_val: "no_reg_akta_lahir",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tempat Lahir",
					type: "text",
					key_check: "tempat_lahir",
					key_val: "nama_tempat_lahir",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tanggal Lahir",
					type: "text",
					key_check: "tanggal_lahir",
					key_val: "tanggal_lahir_styled",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Penulisan Tempat & Tanggal Lahir",
					type: "text",
					key_check: "penulisan_ttl",
					key_val: "penulisan_ttl",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Anak ke-",
					type: "text",
					key_check: null,
					key_val: null,
					prefix: "",
					suffix: "",
					fallback: "",
					fallbackClass: "",
					custom: [
						{
							key_check: "anak_ke",
							key_val: "anak_ke",
							prefix: "",
							suffix: " dari ",
							fallback: "[belum diisi] dari ",
						},
						{
							key_check: "jumlah_saudara",
							key_val: "jumlah_saudara",
							prefix: "",
							suffix: " bersaudara",
							fallback: "[belum diisi] bersaudara",
						},
					],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tinggi Badan",
					type: "text",
					key_check: "tinggi_badan",
					key_val: "tinggi_badan",
					prefix: "",
					suffix: " cm",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Berat Badan",
					type: "text",
					key_check: "berat_badan",
					key_val: "berat_badan",
					prefix: "",
					suffix: " kg",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Lingkar Kepala",
					type: "text",
					key_check: "lingkar_kepala",
					key_val: "lingkar_kepala",
					prefix: "",
					suffix: " cm",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Jenis Kebutuhan Khusus",
					type: "text",
					key_check: "berkebutuhan_khusus_id",
					key_val: "jenis_kebutuhan_khusus",
					prefix: "",
					suffix: "",
					fallback: "Tidak ada",
					fallbackClass: "fst-normal",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Alamat",
					type: "text",
					key_check: null,
					key_val: null,
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [
						{
							key_check: "alamat",
							key_val: "alamat",
							prefix: "",
							suffix: "",
							fallback: "[alamat pelengkap belum diisi]",
						},
						{
							key_check: "rt",
							key_val: "rt",
							prefix: " RT ",
							suffix: "",
							fallback: " [rt belum diisi]",
						},
						{
							key_check: "rw",
							key_val: "rw",
							prefix: "/RW ",
							suffix: ", ",
							fallback: "/[rw belum diisi], ",
						},
						{
							key_check: "desa",
							key_val: "nama_desa",
							prefix: "Desa ",
							suffix: ", ",
							fallback: "[desa belum diisi], ",
						},
						{
							key_check: "kecamatan",
							key_val: "nama_kec",
							prefix: "",
							suffix: ", ",
							fallback: "[kecamatan belum diisi], ",
						},
						{
							key_check: "kabupaten_kota",
							key_val: "nama_kab_kota",
							prefix: "",
							suffix: ", ",
							fallback: "[kab/kota belum diisi], ",
						},
						{
							key_check: "provinsi",
							key_val: "nama_prov",
							prefix: "",
							suffix: "",
							fallback: "[provinsi belum diisi]",
						},
					],
					colspan: { xs: 24, sm: 24, md: 16, lg: 16, xl: 16 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tautan Maps",
					type: "link",
					key_check: "google_maps",
					key_val: "google_maps",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 24, md: 8, lg: 8, xl: 8 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tempat Tinggal",
					type: "text",
					key_check: "tempat_tinggal_id",
					key_val: "jenis_tempat_tinggal",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Moda Transportasi",
					type: "text",
					key_check: "moda_transportasi_id",
					key_val: "jenis_transportasi",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Jarak ke Sekolah",
					type: "text",
					key_check: "jarak_tempat_tinggal",
					key_val: "jarak_tempat_tinggal",
					prefix: "",
					suffix: " km",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Waktu Tempuh",
					type: "text",
					key_check: "waktu_tempuh",
					key_val: "waktu_tempuh",
					prefix: "",
					suffix: " menit",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Asal Sekolah",
					type: "text",
					key_check: null,
					key_val: null,
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [
						{
							key_check: "nama_asal_sekolah",
							key_val: "nama_asal_sekolah",
							prefix: "",
							suffix: "",
							fallback: "belum diisi",
						},
						{
							key_check: "npsn_asal_smp",
							key_val: "npsn_asal_smp",
							prefix: " (",
							suffix: ")",
							fallback: " (-)",
						},
					],
					colspan: { xs: 24, sm: 24, md: 9, lg: 9, xl: 8 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nomor Seri Ijazah SMP/MTs",
					type: "text",
					key_check: "no_seri_ijazah_smp",
					key_val: "no_seri_ijazah_smp",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 9, lg: 9, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Pendidikan Dasar",
					type: "text",
					key_check: "pendidikan_dasar_id",
					key_val: "deskripsi_pd",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Pernah PAUD Formal",
					type: "text",
					key_check: "pernah_paud_formal",
					key_val: "pernah_paud_formal_text",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 5, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Pernah PAUD Nonformal",
					type: "text",
					key_check: "pernah_paud_nonformal",
					key_val: "pernah_paud_nonformal_text",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 5, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Hobi",
					type: "text",
					key_check: "hobi_id",
					key_val: "nama_hobi",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 7, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Cita-cita",
					type: "text",
					key_check: "cita_cita_id",
					key_val: "nama_cita_cita",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 7, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Foto Siswa",
					type: "image",
					key_check: "foto_diri",
					key_val: "previewFotoDiri",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Foto Ijazah SMP/MTs",
					type: "image",
					key_check: "foto_ijazah_smp",
					key_val: "previewFotoIjazahSMP",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Foto Kartu Keluarga",
					type: "image",
					key_check: "foto_kk",
					key_val: "previewFotoKK",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Foto Akta Kelahiran",
					type: "image",
					key_check: "foto_akta",
					key_val: "previewFotoAkta",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Catatan",
					type: "text",
					key_check: "catatan",
					key_val: "catatan",
					prefix: "",
					suffix: "",
					fallback: "Tidak ada",
					fallbackClass: "fst-normal",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Terakhir diperbarui",
					type: "text",
					key_check: "updated_at",
					key_val: "updated_at_styled",
					prefix: "",
					suffix: "",
					fallback: "belum ada perubahan",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
			],
		};
	},
	props: {
		progresData: Object,
		dataRinciSiswa: Object,
		loadingData: Object,
		formOptions: Object,
		refreshDataParent: Function,
		refreshFormOption: Function,
		updateEditing: Function,
		siswaId: Number,
		isPengelola: Boolean,
		isWaliKelas: Boolean,
		isSiswa: Boolean,
		breakpoint: String,
	},
	computed: {
		detailSiswa() {
			return this.dataRinciSiswa["detailSiswa"] || {};
		},
		listKebutuhanKhusus() {
			return this.formOptions["listKebutuhanKhusus"];
		},
		listProvinsi() {
			return this.formOptions["listProvinsi"];
		},
		listTempatTinggal() {
			return this.formOptions["listTempatTinggal"];
		},
		listModaTransportasi() {
			return this.formOptions["listModaTransportasi"];
		},
		listPendidikanDasar() {
			return this.formOptions["listPendidikanDasar"];
		},
		listHobi() {
			return this.formOptions["listHobi"];
		},
		listCitaCita() {
			return this.formOptions["listCitaCita"];
		},
		loading() {
			return this.loadingData["detailSiswa"];
		},
		formChanged() {
			return this.originalForm !== JSON.stringify(this.form);
		},
		hasMoreTempatLahir() {
			return (this.pageSearchTempatLahir - 1) * this.limitSearch <= this.listTempatLahir.length;
		},
		hasMoreAsalSMP() {
			return (this.pageSearchAsalSMP - 1) * this.limitSearch <= this.listAsalSMP.length;
		},
	},
	watch: {
		"progresData.kunci_data"(val) {
			if (val && this.edit && !this.isPengelola) {
				this.$alert("Akses edit data ditutup oleh petugas. Silakan hubungi petugas untuk membuka akses edit.", "Peringatan", {
					confirmButtonText: "Baik",
				});
				this.edit = false;
			}
		},
		detailSiswa: {
			immediate: true,
			handler(val) {
				if (val.provinsi) {
					this.getListKabKota(val.provinsi, true);
				}
				if (val.kabupaten_kota) {
					this.getListKecamatan(val.kabupaten_kota, true);
				}
				if (val.kecamatan) {
					this.getListDesa(val.kecamatan, true);
				}
			},
		},
		"form.provinsi"(val, oldVal) {
			const provChanged = val && val !== this.detailSiswa.provinsi;
			if (provChanged) {
				if (this.detailSiswa.kabupaten_kota) {
					this.alamatAwal.nama_kab_kota = null;
					this.rules.kabupaten_kota = [{ required: true, message: "Kabupaten/kota harus diisi", trigger: "change" }];
				}
				if (this.detailSiswa.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				}
				if (this.detailSiswa.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.kabupaten_kota = null;
				this.form.kecamatan = null;
				this.form.desa = null;

				this.getListKabKota(val);
				this.listKecamatan = [];
				this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.detailSiswa.provinsi) this.form.kabupaten_kota = null;

				this.listKabKota = this.listKabKotaAwal;
				this.alamatAwal.nama_kab_kota = this.detailSiswa.nama_kab_kota;
				this.rules.kabupaten_kota = [];

				const kabChanged = this.form.kabupaten_kota && this.form.kabupaten_kota !== this.detailSiswa.kabupaten_kota;
				const kecChanged = this.form.kecamatan && this.form.kecamatan !== this.detailSiswa.kecamatan;

				if (kabChanged && this.detailSiswa.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				} else {
					this.listKecamatan = this.listKecamatanAwal;
					this.alamatAwal.nama_kec = this.detailSiswa.nama_kec;
					this.rules.kecamatan = [];
				}
				if ((kabChanged || kecChanged) && this.detailSiswa.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				} else {
					this.listDesa = this.listDesaAwal;
					this.alamatAwal.nama_desa = this.detailSiswa.nama_desa;
					this.rules.desa = [];
				}
			}
		},
		"form.kabupaten_kota"(val, oldVal) {
			const provChanged = this.form.provinsi && this.form.provinsi !== this.detailSiswa.provinsi;
			const kabChanged = val && val !== this.detailSiswa.kabupaten_kota;
			if (kabChanged || provChanged) {
				if (this.detailSiswa.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				}
				if (this.detailSiswa.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.kecamatan = null;
				this.form.desa = null;

				if (kabChanged) this.getListKecamatan(val);
				else this.listKecamatan = [];

				this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.detailSiswa.kabupaten_kota) this.form.kecamatan = null;

				this.listKecamatan = this.listKecamatanAwal;
				this.alamatAwal.nama_kec = this.detailSiswa.nama_kec;
				this.rules.kecamatan = [];

				const kecChanged = this.form.kecamatan && this.form.kecamatan !== this.detailSiswa.kecamatan;
				if (kecChanged && this.detailSiswa.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				} else {
					this.listDesa = this.listDesaAwal;
					this.alamatAwal.nama_desa = this.detailSiswa.nama_desa;
					this.rules.desa = [];
				}
			}
		},
		"form.kecamatan"(val, oldVal) {
			const provChanged = this.form.provinsi && this.form.provinsi !== this.detailSiswa.provinsi;
			const kabChanged = this.form.kabupaten_kota && this.form.kabupaten_kota !== this.detailSiswa.kabupaten_kota;
			const kecChanged = val && val !== this.detailSiswa.kecamatan;
			if (kecChanged || kabChanged || provChanged) {
				if (this.detailSiswa.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.desa = null;
				if (kecChanged) this.getListDesa(val);
				else this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.detailSiswa.kecamatan) this.form.desa = null;

				this.listDesa = this.listDesaAwal;
				this.alamatAwal.nama_desa = this.detailSiswa.nama_desa;
				this.rules.desa = [];
			}
		},
		edit(val) {
			if (val) {
				this.alamatAwal = {
					nama_desa: this.detailSiswa.nama_desa,
					nama_kec: this.detailSiswa.nama_kec,
					nama_kab_kota: this.detailSiswa.nama_kab_kota,
					nama_prov: this.detailSiswa.nama_prov,
				};
			} else {
				this.$refs.formDetailSiswa.resetFields();
				this.form.previewFotoDiri = "";
				this.form.previewFotoIjazahSMP = "";
				this.form.previewFotoKK = "";
				this.form.previewFotoAkta = "";
			}
		},
		formChanged(val) {
			this.updateEditing(val);
		},
	},
	mounted() {
		this.originalForm = JSON.stringify(this.form);
		this.refreshFormOption("listKebutuhanKhusus");
		this.refreshFormOption("listProvinsi");
		this.refreshFormOption("listTempatTinggal");
		this.refreshFormOption("listModaTransportasi");
		this.refreshFormOption("listPendidikanDasar");
		this.refreshFormOption("listHobi");
		this.refreshFormOption("listCitaCita");
	},
	beforeUnmount() {},
	beforeRouteLeave(to, from, next) {
		if (this.formChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		numberValidator(rule, value, callback) {
			if (value === null || value === undefined || value === "") {
				callback();
			} else if (isNaN(value) || Number(value) < 1) {
				callback(new Error("Nilai harus lebih besar dari 0"));
			} else {
				callback();
			}
		},
		handleFotoDiriChange(file) {
			if (file) {
				this.form.foto_diri = file.raw;
				this.form.previewFotoDiri = URL.createObjectURL(file.raw);
			} else {
				this.form.foto_diri = null;
				this.form.previewFotoDiri = "";
			}
		},
		handleIjazahChange(file) {
			if (file) {
				this.form.foto_ijazah_smp = file.raw;
				this.form.previewFotoIjazahSMP = URL.createObjectURL(file.raw);
			} else {
				this.form.foto_ijazah_smp = null;
				this.form.previewFotoIjazahSMP = "";
			}
		},
		handleKKChange(file) {
			if (file) {
				this.form.foto_kk = file.raw;
				this.form.previewFotoKK = URL.createObjectURL(file.raw);
			} else {
				this.form.foto_kk = null;
				this.form.previewFotoKK = "";
			}
		},
		handleAktaChange(file) {
			if (file) {
				this.form.foto_akta = file.raw;
				this.form.previewFotoAkta = URL.createObjectURL(file.raw);
			} else {
				this.form.foto_akta = null;
				this.form.previewFotoAkta = "";
			}
		},
		onVisibleChangeTempatLahir(visible) {
			if (visible) {
				this.loadMoreTempatLahir(this.keywordTempatLahir, true);
			} else {
				this.keywordTempatLahir = "";
			}
		},
		handleScrollTempatLahir(e) {
			const dropdown = document.querySelector(".tempat-lahir-dropdown .el-select-dropdown__wrap");

			if (!dropdown) return;

			const nearBottom = e.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10;

			if (nearBottom) this.loadMoreTempatLahir(this.keywordTempatLahir);
		},
		onKeyupTempatLahir(e) {
			const val = e.target.value;
			if (val === this.keywordTempatLahir) return;
			this.keywordTempatLahir = val;

			this.loadMoreTempatLahir(val);
		},
		loadMoreTempatLahir(query, immediate = false) {
			if (!this.hasMoreTempatLahir || this.loadingTempatLahir) return;

			clearTimeout(this.debounceTempatLahir);
			this.isFetchingTempatLahir = true;

			const runFetch = async () => {
				this.isFetchingTempatLahir = false;
				const log = this.searchLogTempatLahir.get(query);
				const keys = Array.from(this.searchLogTempatLahir.keys());
				const parentKey = keys.filter((k) => k && query.toLowerCase().includes(k.toLowerCase())).sort((a, b) => b.length - a.length)[0] || null;

				if (parentKey) {
					const parentLog = this.searchLogTempatLahir.get(parentKey);
					const parentLogHasMore = parentLog.page * this.limitSearch <= parentLog.total;
					if (!parentLogHasMore) return;
				}

				if (log) {
					const logHasMore = log.page * this.limitSearch <= log.total;

					if (!logHasMore) return;

					await this.getListTempatLahir(query, (log.page - 1) * this.limitSearch);
					return;
				}

				if (query) {
					await this.getListTempatLahir(query, 0);
					return;
				}

				await this.getListTempatLahir(query, (this.pageSearchTempatLahir - 1) * this.limitSearch);
			};

			if (immediate) runFetch();
			else this.debounceTempatLahir = setTimeout(runFetch, 500);
		},
		async getListTempatLahir(query = null, offset) {
			this.loadingTempatLahir = true;
			try {
				const { data } = await this.$defaultApi.post("/list/tempat-lahir", {
					key: query,
					limit: this.limitSearch,
					offset,
				});

				const merged = [...this.listTempatLahir, ...data.tempat_lahir];
				this.listTempatLahir = [...new Map(merged.map((item) => [item.wilayah_id, item])).values()];

				if (query) {
					const log = this.searchLogTempatLahir.get(query);
					if (log) {
						this.searchLogTempatLahir.set(query, {
							page: log.page + 1,
							total: log.total + data.tempat_lahir.length,
						});
					} else {
						this.searchLogTempatLahir.set(query, {
							page: 1,
							total: data.tempat_lahir.length,
						});
					}
				} else {
					this.pageSearchTempatLahir++;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.loadingTempatLahir = false;
			}
		},
		async getListKabKota(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/kab-kota", {
					parent_id: parentId,
				});

				if (awal) this.listKabKotaAwal = data.kab_kota;
				this.listKabKota = data.kab_kota;
			} catch (error) {
				console.error(error);
			}
		},
		async getListKecamatan(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/kecamatan", {
					parent_id: parentId,
				});

				if (awal) this.listKecamatanAwal = data.kecamatan;
				this.listKecamatan = data.kecamatan;
			} catch (error) {
				console.error(error);
			}
		},
		async getListDesa(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/desa", {
					parent_id: parentId,
				});

				if (awal) this.listDesaAwal = data.desa;
				this.listDesa = data.desa;
			} catch (error) {
				console.error(error);
			}
		},
		onVisibleChangeAsalSMP(visible) {
			if (visible) {
				this.loadMoreAsalSMP(this.keywordAsalSMP, true);
			} else {
				this.keywordAsalSMP = "";
			}
		},
		handleScrollAsalSMP(e) {
			const dropdown = document.querySelector(".asal-smp-dropdown .el-select-dropdown__wrap");

			if (!dropdown) return;

			const nearBottom = e.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10;

			if (nearBottom) this.loadMoreAsalSMP(this.keywordAsalSMP);
		},
		onKeyupAsalSMP(e) {
			const val = e.target.value;
			if (val === this.keywordAsalSMP) return;
			this.keywordAsalSMP = val;

			this.loadMoreAsalSMP(val);
		},
		loadMoreAsalSMP(query, immediate = false) {
			if (!this.hasMoreAsalSMP || this.loadingAsalSMP) return;

			clearTimeout(this.debounceAsalSMP);
			this.isFetchingAsalSMP = true;

			const runFetch = async () => {
				this.isFetchingAsalSMP = false;
				const log = this.searchLogAsalSMP.get(query);
				const keys = Array.from(this.searchLogAsalSMP.keys());
				const parentKey = keys.filter((k) => k && query.toLowerCase().includes(k.toLowerCase())).sort((a, b) => b.length - a.length)[0] || null;

				if (parentKey) {
					const parentLog = this.searchLogAsalSMP.get(parentKey);
					const parentLogHasMore = parentLog.page * this.limitSearch <= parentLog.total;
					if (!parentLogHasMore) return;
				}

				if (log) {
					const logHasMore = log.page * this.limitSearch <= log.total;

					if (!logHasMore) return;

					await this.getListAsalSMP(query, (log.page - 1) * this.limitSearch);
					return;
				}

				if (query) {
					await this.getListAsalSMP(query, 0);
					return;
				}

				await this.getListAsalSMP(query, (this.pageSearchAsalSMP - 1) * this.limitSearch);
			};

			if (immediate) runFetch();
			else this.debounceAsalSMP = setTimeout(runFetch, 500);
		},
		async getListAsalSMP(query = null, offset) {
			this.loadingAsalSMP = true;
			try {
				const { data } = await this.$defaultApi.post("/list/asal-smp", {
					key: query,
					limit: this.limitSearch,
					offset,
				});

				const merged = [...this.listAsalSMP, ...data.asal_smp];
				this.listAsalSMP = [...new Map(merged.map((item) => [item.npsn, item])).values()];

				if (query) {
					const log = this.searchLogAsalSMP.get(query);
					if (log) {
						this.searchLogAsalSMP.set(query, {
							page: log.page + 1,
							total: log.total + data.asal_smp.length,
						});
					} else {
						this.searchLogAsalSMP.set(query, {
							page: 1,
							total: data.asal_smp.length,
						});
					}
				} else {
					this.pageSearchAsalSMP++;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.loadingAsalSMP = false;
			}
		},
		async updateData() {
			this.loadingForm = true;

			const formData = new FormData();
			let changedFields = 0;
			for (const [key, value] of Object.entries(this.form)) {
				if (value || typeof value === "number") {
					changedFields++;
					formData.append(key, value);
				}
			}
			try {
				if (changedFields === 0) {
					throw Error("Belum ada perubahan");
				}

				const valid = await this.$refs.formDetailSiswa.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				formData.append("siswa_id", this.siswaId);
				const { data } = await this.$defaultApi.post("/detail/siswa/update", formData);
				this.edit = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingForm = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
